import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-title-area item-bg1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "page-title-content" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, null, -1)
const _hoisted_7 = { class: "primery-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("Anasayfa")
              ]),
              _: 1
            })
          ]),
          _hoisted_6,
          _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.mainTitle), 1)
        ])
      ])
    ])
  ]))
}